import { db } from '../../firebase.js';
export default({
    state:{
        gridGallery: [],
        actualImage: [],
        showImage: false
    },
    mutations:{
        bindGridItems(state){
            db.collection('gridGallery')
            .get()
            .then(querySnapshot=>{
                querySnapshot.forEach(doc=>{
                    let url = doc.data().url;
                    let name = doc.data().name;
                    let cls = doc.data().class;
                    state.gridGallery.push({
                      url,
                      name,
                      cls
                    })
                })
            })
        },
        fullImage(state, item){
            state.showImage = !state.showImage;
            if(item){
                state.actualImage = item;
            }
        }
    },
    actions:{
        fullImage({ commit }, item){
            commit('fullImage', item)
        }
    },
    getters:{}
})